import React, { useEffect } from "react";

const Compliance = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="px-4 sm:px-32 pt-4 sm:pt-28">
      <h1 className="text-3xl font-bold mb-12">Compliance Practices</h1>
      <h2 className="text-xl mt-8 mb-3 font-semibold">VM Security:</h2>
      <p className="mb-6">
        As an organization committed to security and compliance, we are pleased
        to share detailed information about our efforts in this area:
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        ISO 27001 Certification:
      </h2>
      <p className="mb-6">
        {`We have successfully completed our ISO 27001 certification,
        demonstrating our commitment to establishing and maintaining a robust
        Information Security Management System (ISMS).`}
      </p>
      <p className="mb-6">
        This certification is evidence of our dedication to protecting the
        confidentiality, integrity, and availability of our information assets.
        We are proud to provide a PDF proof of our ISO 27001 certification to
        stakeholders upon request.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        {`SOC 2 Type II Certified:`}
      </h2>
      <p className="mb-6">
        We are SOC 2 Type II certified, which is a testament to
        our commitment to security, availability, processing integrity,
        confidentiality, and privacy.
      </p>
      <p className="mb-6">
        This accomplishment underscores our dedication to maintaining high
        standards of security and operational excellence.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">
        {`Vulnerability Assessment and Penetration Testing (VA PT) (In Progress):`}
      </h2>
      <p className="mb-6">
        We are actively undergoing VA PT to identify and address potential
        security vulnerabilities within our systems.
      </p>
      <p className="mb-6">
        This proactive approach to security ensures that we are continuously
        improving our defenses against potential threats.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">
        {"Internal Review (Completed):"}
      </h2>
      <p className="mb-6">
        We have completed an internal review to evaluate and enhance our
        internal processes and security measures.
      </p>
      <p className="mb-6">
        This review helps us ensure that our operations are efficient and that
        our security measures are effective in protecting our organization.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">Internal Processes:</h2>
      <p className="mb-6">
        We have established robust internal processes to ensure the smooth and
        secure operation of our organization.
      </p>
      <p className="mb-6">
        These processes are designed to support our commitment to security,
        compliance, and operational excellence.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Development and Security Measures:
      </h2>

      <p className="mb-6">
        We have implemented comprehensive development and security measures to
        safeguard our systems and data.
      </p>
      <p className="mb-6">
        These measures are integral to our overall security strategy and
        demonstrate our dedication to maintaining a secure environment.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">{`Web Application Firewall (WAF)`}</h2>

      <p className="mb-6">
        Rule Sets: We configure WAF rule sets to protect against common web
        vulnerabilities such as SQL injection, cross-site scripting (XSS), and
        cross-site request forgery (CSRF).
      </p>
      <p className="mb-6">
        Custom Rules: We create custom WAF rules to address specific security
        concerns and protect against targeted attacks.
      </p>

      <p className="mt-12 mb-6 italic">
        We are committed to transparency and continuous improvement in all
        aspects of our operations, including security and compliance.
      </p>
      <p className="mb-6 italic">
        We welcome inquiries from our stakeholders and are happy to provide
        further information and documentation as needed.
      </p>
    </div>
  );
};

export default Compliance;
